import { createSlice, configureStore } from '@reduxjs/toolkit'

const videosSlice = createSlice({
  name: 'videos',
  initialState: {
    videos: [],
    sortOptions: ['releaseDate', 'viewCount'],
    filters: {
      genres: ['Movies', 'Comedy', 'Lifestyle', 'Sports', 'Education'],
      contentRatings: ['Anyone', '7+', '12+', '16+', '18+'],
    },
    query: {
      genres: ['All'],
      contentRating: '',
      title: '',
    },
  },
  reducers: {
    updateSortOptions: (state, action) => {
        state.sortOptions = action.payload;
    },
    updateGenres: (state, action) => {
        state.filters.genres = action.payload;
    },
    updateContentRatings: (state, action) => {
        state.filters.contentRatings = action.payload;
    },
    updateFilter: (state, action) => {
        state.filters = action.payload
    },
    updateVideos: (state, action) => {
      state.videos = action.payload
    },
    updateQuery: (state, action) => {
      state.query = action.payload
    },
    updateQueryGenres: (state, action) => {
      state.query.genres = action.payload
    },
    updateQueryContentRating: (state, action) => {
      state.query.contentRating = action.payload
    },
    updateQueryTitle: (state, action) => {
      state.query.title = action.payload
    }
  }
})

export const { 
  updateSortOptions, 
  updateGenres, 
  updateContentRatings, 
  updateFilter, 
  updateVideos, 
  updateQuery,
  updateQueryGenres,
  updateQueryContentRating,
  updateQueryTitle
} = videosSlice.actions

export const store = configureStore({
  reducer: videosSlice.reducer
})

export default videosSlice.reducer